type ModalCloseButtonProps = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  'aria-label': string
  className?: string
  /** Light = on white modal; dark = on dark overlay / lightbox */
  variant?: 'light' | 'dark'
}

export default function ModalCloseButton({
  onClick,
  'aria-label': ariaLabel,
  className = '',
  variant = 'light',
}: ModalCloseButtonProps) {
  return (
    <button
      type="button"
      className={`ui-close-btn ui-close-btn--${variant}${className ? ` ${className}` : ''}`}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path strokeLinecap="round" d="M6 6l12 12M18 6 6 18" />
      </svg>
    </button>
  )
}
